import { Component, OnInit } from '@angular/core';
import { CutOffTimes } from '@approot/models';
import { ConfigService } from '@approot/services';
import { DisplayDefinitionsService } from '../display-definitions.service';

@Component({
  selector: 'app-cutoffs',
  templateUrl: './cutoffs.component.html',
  styleUrls: ['./cutoffs.component.scss']
})
export class CutoffsComponent implements OnInit {
  public sources: CutOffTimes[];

  constructor(
    private svc: DisplayDefinitionsService,
    private configService: ConfigService
  ) {}

  public ngOnInit() {
    this.configService
      .getCutOffTimes()
      .subscribe(cutoffs => (this.sources = cutoffs));
  }

  public get modalOpen(): boolean {
    return this.svc.showCutoffs;
  }

  public modalChanged(event: boolean) {
    this.svc.showCutoffs = event;
  }
}
